import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

import { Text } from '@ingka/common-styles-webc';

export default class ShareDesignCardStyle {
	/**
	 * Returns styles.
	 *
	 * @param options The props.
	 * @param options.theme Theme.
	 * @returns Styles.
	 */
	public static getStyle(options: { theme: ITheme }): string {
		const { color, spacing, border } = options.theme;

		return css`
			${Text.CSS}

			.title {
				display: block;
				margin-bottom: ${spacing.space150 / 16}rem;
				margin-top: 0;
			}

			.default-description {
				display: block;
				margin-bottom: ${spacing.space150 / 16}rem;
			}
			.default-description h3 {
				margin: 0;
			}

			.description {
				display: block;
				margin-bottom: ${spacing.space250 / 16}rem;
			}

			.designCodeText p {
				color: ${color.text.dark};
				margin-bottom: ${spacing.space250 / 16}rem;
			}

			skapa-button {
				display: block;
			}

			.spacer {
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			skapa-inline-message {
				margin-top: ${spacing.space100 / 16}rem;
			}

			skapa-image {
				width: 100%;
				margin-bottom: ${spacing.space125 / 16}rem;
			}

			skapa-image img {
				display: block;
			}

			.qr-code {
				display: flex;
				flex-direction: column;
				padding: ${spacing.space250 / 16}rem;
				border-radius: ${border.radius.radius8 / 16}rem;
				background-color: ${color.neutral.grey100};
			}

			.qr-code-container {
				padding: ${spacing.space75 / 16}rem;
				margin: 0 auto;
				border-radius: ${border.radius.radius4 / 16}rem;
				background-color: ${color.neutral.white};
			}

			kompis-qr-code {
				display: block;
				max-width: ${209 / 16}rem;
			}

			.qr-code-text {
				margin-top: ${spacing.space250 / 16}rem;
				margin-bottom: 0;
				text-align: center;
			}

			.design-changes-disclaimer {
				margin-top: ${spacing.space150 / 16}rem;
				margin-bottom: 0;
				text-align: center;
			}
		`;
	}
}
